import { shpToGeoJSONFromFileInput } from "./format/shp";
import { geojsonFromFileInput } from "./format/geojson";
import { parseGeoJSON, splitGeoJSON } from "./format/utils";
async function runConversion(conversion, filefield, apiKey) {
    return new Promise((resolve, reject) => {
        const title = document.createElement("input");
        title.setAttribute("type", "text");
        title.setAttribute("name", "title");
        const myform = document.createElement("form");
        myform.appendChild(filefield);
        myform.appendChild(title);
        const data = new FormData(myform);
        fetch(conversion + "/upload", {
            method: "POST",
            headers: {
                "x-api-key": apiKey,
            },
            body: data,
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            return response.json();
        })
            .then((responseData) => {
            const geojson = responseData.data;
            const layername = responseData.layername || "newlayer";
            resolve({
                data: geojson,
                title: layername,
                srid: -1,
            });
        })
            .catch((e) => {
            reject(Error(e.message + ". Could not upload the file."));
        });
    });
}
/**
 * Converts data from various formats into a GeoJSON.
 * @param filefield HTML File Field
 * @param url for backend / conversion
 * @returns List of a part of the layer configuration for a memory layer
 */
export async function importGeoJSONFromFile(filefield, conversion, apiKey) {
    const fileending = filefield.files[0].name.split(".").slice(-1)[0];
    let import_geojson;
    let import_title;
    let import_srid;
    let get_layer_fnc = (feature) => import_title;
    switch (fileending) {
        case "zip":
        case "shp":
        case "prj":
        case "dbf": {
            const shape_imports = await shpToGeoJSONFromFileInput(filefield);
            import_geojson = shape_imports.data;
            import_title = shape_imports.title;
            import_srid = shape_imports.srid;
            break;
        }
        case "json":
        case "geojson": {
            const geojson_imports = await geojsonFromFileInput(filefield);
            import_geojson = geojson_imports.data;
            import_title = geojson_imports.title;
            import_srid = geojson_imports.srid;
            break;
        }
        case "gml":
        case "dxf": {
            const conversion_imports = await runConversion(conversion, filefield, apiKey);
            import_geojson = conversion_imports.data;
            import_title = conversion_imports.title;
            import_srid = conversion_imports.srid;
            if (fileending == "dxf")
                get_layer_fnc = (feature) => feature.properties["Layer"];
            break;
        }
    }
    if (!(typeof import_geojson === "undefined") &&
        !(typeof import_title === "undefined") &&
        !(typeof import_srid === "undefined")) {
        const { data, valid, message } = parseGeoJSON(import_geojson, import_srid == 4326, false);
        if (valid) {
            const splitted_geojson = splitGeoJSON(data, get_layer_fnc);
            return splitted_geojson.map((s) => {
                return {
                    data: s.data,
                    title: s.title,
                    srid: import_srid,
                    topic: import_title,
                };
            });
        }
        else {
            throw Error(message);
        }
    }
    else {
        throw Error("notsupportedformat");
    }
}
//# sourceMappingURL=fileimport.js.map